<template>
  <div>
    <div class="UploadButton_button_2t1mnl">
      <div class="UploadButton_body_1JyBNF" @click="upLoad">上传素材</div>
      <div class="UploadButton_upload_1Uy8n4">
        <div class="UploadButton_trigger_3lBjto">
          <img
            v-if="show==false"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA8CAYAAAApK5mGAAAA30lEQVR4Ae3SMS5AQRSF4VGiw9bsQQ9ApQewGQGJHsQmNLZwnLh5ceNJJpFXzPB/ySmm/Gem4P8CAAAAAEg68Fb/Ssyhvqz1HnOksfVeY44V7rx379V7UdjoLeYkxcx7b969t+Q9K2z2EnOqcOvNFRuCin2L2mo95kzhZojJQem86D0pbLcac65wnWPGQT9G7bQUMuNdpJjZYrWgFPWosFtakGKuckw9KEha8B4U9loIWvEuh5haUCVqv5lvV+x3QSEupBM5qGMEEUQQQQQBkLQ85VoImhQvBAAAAAD49AHOAGNJjjUrDQAAAABJRU5ErkJggg=="
            class="UploadButton_img_3eRfyV"
          />
          <img
            v-if="show"
            src="data:image/gif;base64,R0lGODlhNAA8AIABAP///////yH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpmODc4NmI1NS1kYmJhLTQ1MDktODBkZi1kYzY5OTg0ZWRlNjciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTgwNzNFMUQ5NkJEMTFFNzlFQzNFMzI0N0I3NjEyQTMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTgwNzNFMUM5NkJEMTFFNzlFQzNFMzI0N0I3NjEyQTMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpmODc4NmI1NS1kYmJhLTQ1MDktODBkZi1kYzY5OTg0ZWRlNjciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Zjg3ODZiNTUtZGJiYS00NTA5LTgwZGYtZGM2OTk4NGVkZTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkECQAAAQAsAAAAADQAPAAAAneMj6nL7Q+jnLTai7PevPsPhuJIluaJpurKosDbLu8cI/NdB/ce7z7rg+FSPJrOaOIdAYchSbm0IUPQqBQmchqmW27H67VSZVgFcxXulXPdM7v9bq7Z6VYdOM/d4/y+nx4UqAUiWOj2h5iouMjY6PgIGSk5SclSAAAh+QQJAAABACwAAAAANAA8AAACeYyPqcvtD6OctNqLs968+w+G4kiW5omm6soBLsu4MpzINm3YOq33bP+6pXazgNC0M75yRVJSCUAcQ09orQmaWq/LbPeABX8/UUUY/Bvjtmtxuc18w884Ok9dx9/l8L7/DxhoBkSoRVaIKKi4yNjo+AgZKTlJWWkZUgAAIfkECQAAAQAsAAAAADQAPAAAAniMj6nL7Q+jnLTai7PevPsPhuJIluaJpuoDtGvTxq8S1/NR53fOv7xrS+lkgaBJV3QZjCNkEoBggpzPhNQjJUa1H+5SaQVPF16cT3zDodNV9hbqVsPjbXo5fd+t6fy+/w/o9zNINUV4GJiouMjY6PgIGSk5SVk5UQAAIfkECQAAAQAsAAAAADQAPAAAAnmMj6nL7Q+jnLTai7PevPsPhuJIluaJmsCaPuvbMu8cJ/NdG/de7yydwsECQBVwSESOcDrWoRhiNgE25QeapFadIGt24e1ot7IeN0dGK8Jods5tHquf5/nXTpfj9/y+/w8YuOVDWHdViCiouMjY6PgIGSk5SVlpGVAAACH5BAkAAAEALAAAAAA0ADwAAAJ5jI+py+0Po5y02ouz3rz7D4biSJbmaQEqCqku27gyrMg2fdg6rq8ze3sFfqbbcGUgjoxHAEIJYjYTUA9U+MR+tEkk1RtdcHM8MO7rPIvN6m66nX3D3fN4Pcduj+/8vv8PGCh411MoFWWYOLjI2Oj4CBkpOUlZaTlYAAAh+QQJAAABACwAAAAANAA8AAACd4yPqcvtD6OctNqLs968+w+G4kiWZgCkZ5S2q9PG7xLXM1LnN5oDvPqyuX6+k+13kJWOyORQxGw6gSHlVGH9PK9YKqiY2OJ24h3Oaz6D02p2d+2WxuXxMts+z+v3/L7/D+jXMxj1RXgYmKi4yNjo+AgZKTlJGVgAACH5BAkAAAEALAAAAAA0ADwAAAJ6jI+py+0Po5y02ouz3rz7D4biSFLAWU7nmkLr2zbvHCvzXR83Ctc0G+ilaEGUQTgiFgEIJEi5TDg9TmDT+sEejVLuc6HV5bbMscxr7pbTNjSb/G6v43C6zv0O2/f8vv8PGCg46LdjCPV0qEjI2Oj4CBkpOUlZaXnJVgAAIfkECQAAAQAsAAAAADQAPAAAAneMj6nL7Q+jnLTai7PevPsPhuIHlGNVpqeUtuvTxi8T13NSm+4dyGr/e8mAgMPuNCQijqGkchkEMZ9QU9NaXURJWiyOZ/SCu8VxY2vOpslrdhsnfqPb87f9js/r9/y+/w8IkTPoJEV4GJiouMjY6PgIGSk5SblWAAAh+QQJAAABACwAAAAANAA8AAACfYyPqcvtD6OctNqLs968+w+GCUCKFomaE8qqEAu7DUzLCl22thGngS6L/Uo8n0o4BCCAIWRyZAQxn1Ci1HqIZrEf5Y2b3S3B4q+3PCOjt+e12c3QwovtOd1exev3/L7/DxgoOEhYSIeDqMaRyFhn+AgZKTlJWWl5iZmp+VAAACH5BAkAAAEALAAAAAA0ADwAAAJ5jI+py+0Po5y02ouz3rz7/wAAmIkiaZkmOqkqC7ku3MjjSyfvGuB5z+MBTzmfcDiC+Ya642fJbBJBzqiUlbwusj9DtbudgmvicZhrVnzT3jL7sGbH0/O3/Y7P6/f8vv8PGChIZVMI9WSYOLjI2Oj4CBkpOUlZaflWAAAh+QQJAAABACwAAAAANAA8AAACd4yPqcvtD6OctNqLs968QwB4GwiKGEmaFYqqEsu6Dxy28tKmgX0ftr4D3nhCnssoDJaOyaQypHI6lTJoYrrr4ZbaCLar+IIR4rGhbEaP1WB2122Oy+f0uv2Oz+v3/L7/70EjGFM1aAiImKi4yNjo+AgZKTlJGVAAACH5BAkAAAEALAAAAAA0ADwAAAJ6jI+py+0Po5y02ouz3g0ADnoeqIkieZkmSqkqG7nfCnfnGdB1QuO5v/uNDEBdzQgUfo7JpJK5RDiFu6h0qLAGr9rtY+plgMNZLNkxPh/Samrb1n2vzfK6/Y7P6/f8vv8PGCg4KCdj+FJ1qEjI2Oj4CBkpOUlZaXkJUwAAIfkECQAAAQAsAAAAADQAPAAAAniMj6nL7Q+jnLTai7MBQHvEcZ8XhiNWlmeVpqvUdurrqGYw08p8472+6f1yOuLPJyoej8gOjclEAp2JKA7YsGKzyS2s64Vow1UwmUs9o9WPMdvNjsvn9Lr9js/r9/y+/w8YuBBD6DJViCiouMjY6PgIGSk5SVlJUwAAIfkEBQAAAQAsAAAAADQAPAAAAkKMj6nL7Q+jnLTai7PevPsPhuJIluaJpurKtu4Lx/JM1/aN5/rO9/4PDAqHxOIOgEwql0sS8/k0SqfUqvWKzWq30gIAOw=="
            class="UploadButton_img_3eRfyV"
          />
          <div class="UploadButton_menu_3XkWxW UploadButton_right_1Di4nI">
            <div class="UploadButton_header_1jFS2i">上传列表({{count}})</div>
            <div class="UploadButton_list_1KDESz">
              <div v-show="show==false" class="UploadButton_empty_1uAX_P">暂无上传素材</div>
              <div v-show="show">
                <div v-for="item in files">
                  <div style="position:relative;height:30px;line-height:30px;">
                    <span
                      style="display:inline-block;position:absolute;left:10px;width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
                    >{{item.name}}</span>
                    <span style="display:inline-block;position:absolute;right:10px;">{{item.num}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input v-if='type==1||type==4' accept="image/*" type="file" ref="inputUp" multiple style="display:none" @change="change1" />
    <input v-if='type==2||type==6' accept="video/*" type="file" ref="inputUp" multiple style="display:none" @change="change1" />
    <input v-if='type==7' accept="audio/*" type="file" ref="inputUp" multiple style="display:none" @change="change1" />
  </div>
</template>
<style scoped>
* {
  box-sizing: border-box;
}
div{
  color:black
}
.UploadButton_button_2t1mnl {
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  height: 30px;
}
.UploadButton_body_1JyBNF {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 15px;
  background-color: #db4437;
  color: #fff;
  border-radius: 4px 0 0 4px;
  display: flex;
  height: 30px;
}
.UploadButton_upload_1Uy8n4 {
  width: 26px;
}
.UploadButton_upload_1Uy8n4:hover .UploadButton_menu_3XkWxW {
  display: block;
}
.UploadButton_trigger_3lBjto {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #cc3629;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  user-select: none;
}
.UploadButton_img_3eRfyV {
  width: 26px;
  height: 30px;
  border: 0;
}
.UploadButton_right_1Di4nI {
  left: auto;
  right: 0;
}
.UploadButton_menu_3XkWxW {
  display: none;
  position: absolute;
  top: 30px;
  right: 0;
  padding-top: 10px;
  z-index: 4999;
  width: 308px;
  background-color: rgba(0, 0, 0, 0);
  cursor: default;
}
.UploadButton_header_1jFS2i {
  padding: 13px 20px;
  background-color: #f3f3f3;
  border: 1px solid #dbdbdb;
}
.UploadButton_list_1KDESz {
  padding: 0 20px;
  background-color: #fff;
  border: 1px solid #dbdbdb;
}
.UploadButton_empty_1uAX_P {
  text-align: center;
  padding: 60px 0;
  color: #7a7a7a;
}
</style>
<script>
import https from '../https.js'
import axios from 'axios'
import md5 from 'js-md5'
export default {
  props: {
    type: String,
    func: Function
  },
  data() {
    return {
      count: 0,
      files: [],
      show: false
    }
  },
  methods: {
    upLoad() {
      this.$refs.inputUp.click()
    },
    change1(e) {
      this.show = true
      var files = e.target.files
      console.log(files)

      const $this = this
      const files1 = []
      for (let i = 0; i < files.length; i++) {
        const item = {}
        item.num = '等待中...'
        item.name = files[i].name
        files1[i] = item
      }
      this.count = files1.length
      this.files = files1
      var i = 0
      function a() {
        const fileReader = new FileReader()
        const blobSlice =
          File.prototype.mozSlice ||
          File.prototype.webkitSlice ||
          File.prototype.slice
        const chunkSize = 2097152
        // read in chunks of 2MB
        const chunks = Math.ceil(files[i].size / chunkSize)
        let currentChunk = 0

        let bir = ''

        var formData = new FormData()
        if ($this.type == 1) {
          formData.append('type', 1)
        } else if ($this.type == 2) {
          formData.append('type', 2)
        } else if ($this.type == 4) {
          formData.append('type', 4)
        } else if ($this.type == 6) {
          formData.append('type', 6)
        } else if ($this.type == 7) {
          formData.append('type', 7)
        }
        // formData.append('type', 2)

        formData.append('file', files[i])
        fileReader.onload = function(e) {
          console.log('read chunk nr', currentChunk + 1, 'of', chunks)
          bir += e.target.result // append binary string
          console.log(formData.get('hashvalue'))
          if(formData.get('hashvalue') == null) {
            formData.append('hashvalue', md5(bir))
          }

          currentChunk++
          if (currentChunk < chunks) {
            loadNext(i)
          } else {
            var options = {
              // 设置axios的参数
              url: '/api/PhysicalFile/UploadFile',
              data: formData,
              method: 'post',
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              onUploadProgress(progressEvent) {
                const val = (
                  (progressEvent.loaded / progressEvent.total) *
                  100
                ).toFixed(0)

                $this.files[i].num = val + '%'
                //   that.formData.showProgress = true;
                //   that.formData.startValue = parseInt(val)
              }
            }
            axios(options).then(res => {
              console.log(res)
              if (res.data.mes === '成功') {
                i++
                if (i < files.length) {
                  a()
                } else {
                  $this.show = false
                  $this.count = 0
                  $this.func(res.data)
                }
              }
            })
          }
        }
        function loadNext(i) {
          var start = currentChunk * chunkSize
          var end =
            start + chunkSize >= files[i].size
              ? files[i].size
              : start + chunkSize
          fileReader.readAsBinaryString(blobSlice.call(files[i], start, end))
        }
        loadNext(i)
      }

      a()
    }
  }
}
</script>>
